
export function getAfterDelimiter(str: string, delimiter: string) {
  return str.split(delimiter)[1];
}
